let lastPartEndsWithSpaceOrSpecSymb = false;

export default (text, saveLineBreaks, previousPartsCount) => {
    if (lastPartEndsWithSpaceOrSpecSymb === undefined) {
        lastPartEndsWithSpaceOrSpecSymb = false;
    }
    const textMatchToSpecSymbols = text.match(/^[-.?!)(,:]/);
    const textStartsWithSpecSymbol = text.match(/^[.?,:)"]/); // if needed - add counting of opening and closing brackets in future for correct trimming
    const textWrappedWithQuotes = text.trim().match(/^"/) && text.trim().match(/"$/);
    if ((textMatchToSpecSymbols && text.trim().length === textMatchToSpecSymbols[0].length) || textStartsWithSpecSymbol) {
        lastPartEndsWithSpaceOrSpecSymb = true;
    }
    //text = text.replace(/^\n\s+/, '\n');
    //text = text.replace(/\n\s+$/g, '\n');
    //text = text.replace(/^[ ][ ]+/, ' ');
    //text = text.replace(/[ ][ ]+$/, ' ');
    if (!saveLineBreaks) {
        text = text.replace(/\n/g, ' ');
    }
    text = text.replace(/^\n/g, '');
    text = text.replace(/\t/g, ' ');
    text = text.replace(/^[ ][ ]+/, '');
    text = text.replace(/[ ][ ]+$/g, '');
    text = text.replace(/[ ][ ]+/g, ' ');
    text = text.trim();
    if (previousPartsCount && !lastPartEndsWithSpaceOrSpecSymb) {
        text = ' ' + text.trim();
    }
    lastPartEndsWithSpaceOrSpecSymb = !textWrappedWithQuotes && (text.endsWith(' ') || text.endsWith('(') || text.endsWith('"'));
    return text;
}